import React from 'react';

const RootsDog = (props) => {
  const { radius, cells } = props;

  const base = cells[1].background;

  return (

    <svg width={`${radius * 1.83}px`} height={`${radius * 1.57}px`} x={`-${radius *.92}px`} y={`-${radius * 1.17}px`} viewBox="0 0 183 157" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Canvas" transform="translate(-8 -3)">
        <g><use xlinkHref="#path0_fill" transform="translate(138.31 3.46343)" fill={base} /></g>
        <g><use xlinkHref="#path1_fill" transform="translate(8.71228 3.46343)" fill={base} /></g>
        <g><use xlinkHref="#path2_fill" transform="translate(66.0767 125.664)" fill="#FFC3BA" /></g>
      </g>
      <defs>
        <path id="path0_fill" d="M 48.8912 56.3337C 53.052 37.7146 53.7701 18.6042 50.9802 0C 33.2173 2.65321 15.9696 8.55619 0 17.2838C 20.7642 25.5966 37.8698 39.3769 48.8912 56.3337Z" />
        <path id="path1_fill" d="M 3.75724 56.3337C -0.403592 37.7146 -1.12167 18.6042 1.66824 0C 19.4311 2.65321 36.6788 8.55619 52.6484 17.2838C 31.8842 25.5966 14.7786 39.3769 3.75724 56.3337Z" />
        <path id="path2_fill" d="M 67.5297 0L 0 1.42109e-14C 5.65455e-23 18.6479 15.117 33.7649 33.7648 33.7649C 52.4127 33.7649 67.5297 18.6479 67.5297 0Z" />
      </defs>
    </svg>
  )
}
export default RootsDog;

export function resize(props) {
  const { radius, minY, maxY } = props;

  return {
    ...props,
    minY: minY + radius * .18,
    maxY: maxY + radius * .4,
  };
}


// WEBPACK FOOTER //
// ./src/core/thematic/rootstech/dog.js